import React, { useState, useEffect } from "react";
import axios from "axios";
import { Drawer, Select, message, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { InputItem, ButtonItem, InputNumberItem, SelectItem, SwitchItem } from "../../../../../Components/Items";

const { Option } = Select;

const TIPOS_SECCION = [
  { value: "almacenamiento", label: "Almacenamiento" },
  { value: "picking", label: "Picking" },
  { value: "recepcion", label: "Recepción" },
  { value: "embarque", label: "Embarque" },
  { value: "cuarentena", label: "Cuarentena" },
  { value: "devoluciones", label: "Devoluciones" },
  { value: "produccion", label: "Producción" },
  { value: "restringida", label: "Restringida" },
  { value: "otro", label: "Otro" },
];

//Panel lateral para editar una sección del almacén (área visual del mapa, no reemplaza a los nodos).
const PanelPropiedadesSeccion = ({ visible, onClose, seccion, headersToken, onGuardado, onEliminado }) => {
  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [tipo, setTipo] = useState("almacenamiento");
  const [prioridadPicking, setPrioridadPicking] = useState(0);
  const [bloqueada, setBloqueada] = useState(false);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (seccion) {
      setCodigo(seccion.codigo || "");
      setNombre(seccion.nombre || "");
      setTipo(seccion.tipo || "almacenamiento");
      setPrioridadPicking(seccion.prioridadPicking || 0);
      setBloqueada(!!seccion.bloqueada);
    }
  }, [seccion]);

  const guardar = async () => {
    setGuardando(true);
    try {
      const res = await axios.post(
        "mapaAlmacen/editarSeccionAlmacen",
        { _id: seccion._id, codigo, nombre, tipo, prioridadPicking },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        message.success("Sección actualizada correctamente");
        onGuardado();
      } else {
        message.error(res.data.error || "No se pudo actualizar la sección");
      }
    } catch (error) {
      console.error("Error al actualizar la sección:", error);
      message.error("No se pudo actualizar la sección");
    } finally {
      setGuardando(false);
    }
  };

  const eliminar = async () => {
    try {
      const res = await axios.post("mapaAlmacen/eliminarSeccionAlmacen", { _id: seccion._id }, { headers: headersToken });
      if (res.data.success === 2) {
        message.success("Sección eliminada correctamente");
        onEliminado();
      } else {
        message.error(res.data.error || "No se pudo eliminar la sección");
      }
    } catch (error) {
      console.error("Error al eliminar la sección:", error);
      message.error("No se pudo eliminar la sección");
    }
  };

  const cambiarBloqueo = async (valor) => {
    setBloqueada(valor);
    try {
      await axios.post("mapaAlmacen/bloquearSeccionAlmacen", { _id: seccion._id, bloqueada: valor }, { headers: headersToken });
      onGuardado();
    } catch (error) {
      console.error("Error al cambiar el bloqueo de la sección:", error);
    }
  };

  if (!seccion) return null;

  return (
    <Drawer title="Propiedades de la sección" visible={visible} onClose={onClose} width={360}>
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Código</div>
        <InputItem value={codigo} onChange={(e) => setCodigo(e.target.value)} />
      </div>

      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Nombre</div>
        <InputItem value={nombre} onChange={(e) => setNombre(e.target.value)} />
      </div>

      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Tipo</div>
        <SelectItem width="100%" value={tipo} onChange={setTipo}>
          {TIPOS_SECCION.map((valorTipo) => (
            <Option key={valorTipo.value} value={valorTipo.value}>
              {valorTipo.label}
            </Option>
          ))}
        </SelectItem>
      </div>

      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Prioridad de picking</div>
        <InputNumberItem style={{ width: "100%" }} value={prioridadPicking} onChange={setPrioridadPicking} />
      </div>

      <div style={{ marginBottom: 20, display: "flex", alignItems: "center", gap: 8 }}>
        <SwitchItem checked={bloqueada} onChange={cambiarBloqueo} />
        <span style={{ color: "#6b7280" }}>Bloqueada (excluida de las rutas)</span>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Popconfirm title="¿Eliminar esta sección?" onConfirm={eliminar} okText="Eliminar" cancelText="Cancelar">
          <ButtonItem danger icon={<DeleteOutlined />}>
            Eliminar
          </ButtonItem>
        </Popconfirm>
        <ButtonItem type="primary" loading={guardando} onClick={guardar}>
          Guardar
        </ButtonItem>
      </div>
    </Drawer>
  );
};

export default PanelPropiedadesSeccion;
